import { buildVenueAnalysisStreamSlice } from 'widgets/venueAnalysis/store/stream/streamSlice';

const { selectors: orderFillsCapsuleStreamedDataSelectors } =
    buildVenueAnalysisStreamSlice();

export { orderFillsCapsuleStreamedDataSelectors };
